<template>
  <div>
    <h3>Other Expense Type Repairing Location</h3>
    <div class="form-row row-cols-md-4 row-cols-1">
      <!-- <div class="col form-group">
        <label class="control-label require">Country:</label>
        <input type="text" class="form-control" v-model="country" id="country" />
      </div> -->
      <div class="col form-group">
        <label class="control-label">State/Province:</label>
        <v-select v-model="state" id="state" name="state" data-info="Please select state" label="text" :filterable="false"
          :options="stateArr" @search="onSearchState" placeholder="Select State" class="custom-ci-auto-search">
          <template slot="no-options">
            Search State...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>
        </v-select>
        <div class="field-error">{{ state_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label">City:</label>
        <v-select v-model="city_id" id="city_id" name="city_id" data-info="Please select city" label="text"
          :filterable="false" :options="cityArr" @search="onSearchCity" placeholder="Select City"
          class="custom-ci-auto-search">
          <template slot="no-options">
            Search City...
          </template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.text }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.text }}
            </div>
          </template>

        </v-select>
        <div class="field-error">{{ city_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label">Street Address:</label>
        <input type="text" class="form-control" v-model="street_address" id="company_name" />
        <div class="field-error">{{ street_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label">Company Name:</label>
        <v-select v-model="location_id" name="location_id" placeholder="Select Location." label="text"
          :options="locationArr">
        </v-select>
        <div class="field-error">{{ location_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label">Zip/Postal Code:</label>
        <input type="text" class="form-control" v-model="zip" id="zip" />
        <div class="field-error">{{ zip_error_msg }}</div>
      </div>
      <div class="col form-group">
        <label class="control-label">Phone Number:</label>
        <input type="text" class="form-control" v-model="phone_no" id="phone_no" />
        <div class="field-error">{{ phone_no_error_msg }}</div>
      </div>
    </div>
    <div class="btn-groups mb-4">
      <button type="button"
        v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvOtherChargesLocationSection",
  props: ["lineItemData", "claimId", "hideEditSection"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    rows: [],
    travelRows: [],
    otherChargesTotalTable: [],
    location_id: null,
    zip: null,
    phone_no: null,
    city_id: null,
    state: null,
    street_address: null,
    locationArr: [],
    stateArr: [],
    cityArr: [],
    state_error_msg: "",
    city_error_msg: "",
    street_error_msg: "",
    location_error_msg: "",
    zip_error_msg: "",
    phone_no_error_msg: "",
  }),
  created(){
    this.populateData();
  },
  methods:{
    populateData(){
      this.loadFieldData(['location']);
      for(let i = 0; i < this.lineItemData[0].rows.length; i++){
          this.rows.push(this.lineItemData[0].rows[i]);
        }
        for(let i = 0; i < this.lineItemData[0].travelRows.length; i++){
          this.travelRows.push(this.lineItemData[0].travelRows[i]);
        }
        for(let i = 0; i < this.lineItemData[0].otherChargesTotalTable.length; i++){
          this.otherChargesTotalTable.push(this.lineItemData[0].otherChargesTotalTable[i]);
        }
        this.location_id = this.lineItemData[0].location_id;
        this.zip = this.lineItemData[0].zip;
        this.phone_no = this.lineItemData[0].phone_no;
        this.city_id = this.lineItemData[0].city_id;
        this.state = this.lineItemData[0].state;
        this.street_address = this.lineItemData[0].street_address;
    },
    onSearchState(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.searchField(loading, search, 'state', '');
      }
    },
    onSearchCity(search, loading) {

      var self = this;
      if (search.length > 2) {

        var stateId = self.state.value;
        if (stateId == "") {
          alert("please select state first");
          return;
        }

        loading(true);
        self.searchField(loading, search, 'city', '');
      }
    },
    onSearchInvoice(search, loading) {
      var self = this;
      if (search.length > 3) {
        loading(true);
        self.searchField(loading, search, 'invoice', '');
      }
    },
    prepareDataForUpdating(){
      const lineItemData = {
        rows: this.rows,
        travelRows: this.travelRows,
        otherChargesTotalTable: this.otherChargesTotalTable,
        state: this.state,
        city_id: this.city_id,
        street_address: this.street_address,
        location_id: this.location_id,
        zip: this.zip,
        phone_no: this.phone_no,
      };
      return lineItemData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/other-charges-location",
          type: "POST",
          data: {
            lineItemData: lineItemData,
            claimId: self.claimId,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("repairing_location_form");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvOtherChargesLocationSection.vue